import styled from 'styled-components';
import spacing from '../../../styles/spacing';
import { vars } from '../../../theme';
import { KanbanBoard } from '../HBKanban.styles';
import {
    StyledColumn,
    StyledColumnContent,
    StyledColumnItems
} from '../HBKanbanColumn/HBKanbanColumn.styles';
import { StyledColumnHeaderContainer } from '../HBKanbanColumn/ColumnHeader/ColumnHeader.styles';
import { getKanbanCardStyles } from '../HBKanbanCard/HBKanbanCard.styles';

// reuse styles, extending when necessary
export const SkeletonBoard = KanbanBoard;
export const SkeletonColumn = StyledColumn;
export const SkeletonColumnHeader = StyledColumnHeaderContainer;
export const SkeletonColumnContent = StyledColumnContent;
// Prevent scrollbars in skeleton columns
export const SkeletonColumnItems = styled(StyledColumnItems)`
    overflow-y: hidden;
`;

// Card styles with default props
export const SkeletonCard = styled.div`
    border-radius: calc(${vars.radius.xl} - 8px);
    padding: ${spacing[8]};
    pointer-events: none; // These are just skeleton cards, we don't want them to be interactive

    ${getKanbanCardStyles({
        $selected: false,
        $isInSelectableState: false,
        $isDragging: false
    })}
`;
